import filterQueryBuilder from 'helpers/filterToQuery'
import { requests, mainApiRoot } from './index'

export const Share = {
  getDomain: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/share/${id}`, query)
  },
  get: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/share/${id}/keywords`, query)
  },
  getResults: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/share/${id}/keywords/results`, query)
  },
  getChanges: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/share/${id}/keywords/changes`, query)
  },
  getCompetitorsResults: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/share/${id}/keywords/competitors/results`, query)
  },
  getCompetitorsChanges: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/share/${id}/keywords/competitors/changes`, query)
  },
  overview: id => requests.get(mainApiRoot, `/share/${id}/overview`),
  visibility: id => requests.get(mainApiRoot, `/share/${id}/visibility`),
  averagePosition: id => requests.get(mainApiRoot, `/share/${id}/average-position`),
  traffic: id => requests.get(mainApiRoot, `/share/${id}/traffic`),
  serpFeatureChart: id => requests.get(mainApiRoot, `/share/${id}/serp-feature-chart`),
  serpFeature: id => requests.get(mainApiRoot, `/share/${id}/serp-feature`),
  position: id => requests.get(mainApiRoot, `/share/${id}/position`),
  serp: (domainId, keywordId) =>
    requests.get(mainApiRoot, `/share/${domainId}/keywords/${keywordId}/serp`),
  history: (domainId, keywordId, filters = {}) => {
    const { startDate, endDate } = filters
    const query = filterQueryBuilder({ startDate, endDate })
    return requests.get(mainApiRoot, `/share/${domainId}/keywords/${keywordId}/history${query}`)
  },
  serpHistory: (domainId, keywordId, filters = {}) => {
    const { startDate, endDate } = filters
    const query = filterQueryBuilder({ startDate, endDate })
    return requests.get(
      mainApiRoot,
      `/share/${domainId}/keywords/${keywordId}/serp-feature-history${query}`
    )
  },
  tags: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/share/${id}/tags${query}`)
  },
  pages: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/share/${id}/keywords/pages/pages_new${query}`)
  },
  pagesChanges: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/share/${id}/keywords/pages/changes${query}`)
  },
  grossing: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/share/${id}/keywords/grossing${query}`)
  },
  discovery: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/share/${id}/keywords/discovery${query}`)
  },
  notifications: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/share/${id}/keywords/notifications${query}`)
  },
  // Export Share Keywords
  exportShareKeywordsExcel: id => requests.getFile(mainApiRoot, `/share/${id}/keywords/excel`),
  exportShareKeywordsCSV: id => requests.getFile(mainApiRoot, `/share/${id}/keywords/csv`),

  // Export Share Competitors
  exportShareCompetitorsExcel: id =>
    requests.getFile(mainApiRoot, `/share/${id}/keywords/competitors/excel`),
  exportShareCompetitorsCSV: id =>
    requests.getFile(mainApiRoot, `/share/${id}/keywords/competitors/csv`),

  // Export Share Pages
  exportSharePagesExcel: id => requests.getFile(mainApiRoot, `/share/${id}/keywords/pages/excel`),
  exportSharePagesCSV: id => requests.getFile(mainApiRoot, `/share/${id}/keywords/pages/csv`),

  // Export Share Metrics
  exportShareMetricsExcel: id =>
    requests.getFile(mainApiRoot, `/share/${id}/keywords/metrics/excel`),
  exportShareMetricsCSV: id => requests.getFile(mainApiRoot, `/share/${id}/keywords/metrics/csv`),

  // Export Share Grossing
  exportShareGrossingExcel: id =>
    requests.getFile(mainApiRoot, `/share/${id}/keywords/grossing/excel`),
  exportShareGrossingCSV: id =>
    requests.getFile(mainApiRoot, `/share/${id}/keywords/grossing/csv`),

  // Export Share Discovery
  exportShareDiscoveryExcel: id =>
    requests.getFile(mainApiRoot, `/share/${id}/keywords/discovery/excel`),
  exportShareDiscoveryCSV: id =>
    requests.getFile(mainApiRoot, `/share/${id}/keywords/discovery/csv`),

  // Export Share Savings
  exportShareSavingsExcel: id =>
    requests.getFile(mainApiRoot, `/share/${id}/keywords/savings/excel`),
  exportShareSavingsCSV: id => requests.getFile(mainApiRoot, `/share/${id}/keywords/savings/csv`),

  // Export Share Notifications
  exportShareNotificationsExcel: id =>
    requests.getFile(mainApiRoot, `/share/${id}/keywords/notifications/excel`),
  exportShareNotificationsCSV: id =>
    requests.getFile(mainApiRoot, `/share/${id}/keywords/notifications/csv`),

  savingsChart: (id, filters) => {
    const query = filterQueryBuilder(filters)
    return requests.get(mainApiRoot, `/share/${id}/keywords/savings-chart${query}`)
  },
  Competitors: {
    overview: (domainId, filters) => {
      const query = filterQueryBuilder(filters)
      return requests.get(mainApiRoot, `/share/${domainId}/competitors/overview${query}`)
    },
    visibility: (domainId, filters) => {
      const query = filterQueryBuilder(filters)
      return requests.get(mainApiRoot, `/share/${domainId}/competitors/visibility${query}`)
    },
    traffic: (domainId, filters) => {
      const query = filterQueryBuilder(filters)
      return requests.get(mainApiRoot, `/share/${domainId}/competitors/traffic${query}`)
    },
    position: (domainId, filters) => {
      const query = filterQueryBuilder(filters)
      return requests.get(mainApiRoot, `/share/${domainId}/competitors/position${query}`)
    },
    averagePosition: (domainId, filters) => {
      const query = filterQueryBuilder(filters)
      return requests.get(mainApiRoot, `/share/${domainId}/competitors/average-position${query}`)
    },
    serpFeature: (domainId, filters) => {
      const query = filterQueryBuilder(filters)
      return requests.get(mainApiRoot, `/share/${domainId}/competitors/serp-feature${query}`)
    },
    serpFeatureChart: (domainId, filters) => {
      const query = filterQueryBuilder(filters)
      return requests.get(
        mainApiRoot,
        `/share/${domainId}/competitors/serp-feature-chart${query}`
      )
    },
    history: (domainId, keywordId, filters = {}) => {
      const { startDate, endDate } = filters
      const query = filterQueryBuilder({ startDate, endDate })
      return requests.get(
        mainApiRoot,
        `/share/${domainId}/competitors/${keywordId}/history${query}`
      )
    }
  },
  WebsiteAudit: {
    getAll: domainId => requests.get(mainApiRoot, `/share/${domainId}/website-audit`),
    getLatest: domainId => requests.get(mainApiRoot, `/share/${domainId}/website-audit/report`),
    get: (domainId, auditId) =>
      requests.get(mainApiRoot, `/share/${domainId}/website-audit/${auditId}/report`),
    getCrawlData: (domainId, auditId) =>
      requests.get(mainApiRoot, `/share/${domainId}/website-audit/${auditId}/crawled-pages`),
    overview: domainId => requests.get(mainApiRoot, `/share/${domainId}/website-audit/overview`)
  }
}
